var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarnRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#FFF5F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10511_3824)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9195 33.1583C47.8946 31.5508 49.629 30.5742 51.4993 30.5742C53.3695 30.5742 55.104 31.5508 56.0791 33.1583L71.1998 58.4016C72.1505 60.048 72.1562 62.0751 71.2147 63.7268C70.2733 65.3784 68.5261 66.4065 66.6055 66.4275L36.3734 66.4274C34.4724 66.4065 32.7253 65.3784 31.7838 63.7268C30.8424 62.0751 30.8481 60.048 31.8132 58.377L46.9195 33.1583ZM34.8877 60.1853C34.5708 60.7341 34.5689 61.4098 34.8828 61.9604C35.1966 62.5109 35.779 62.8536 36.393 62.8605L66.5859 62.8606C67.2196 62.8536 67.802 62.5109 68.1158 61.9604C68.4296 61.4098 68.4277 60.7341 68.1253 60.21L53.0242 34.9997C52.7009 34.4667 52.1227 34.1412 51.4993 34.1412C50.8772 34.1412 50.3002 34.4653 49.9765 34.9962L34.8877 60.1853ZM49.7158 43.242C49.7158 42.257 50.5143 41.4585 51.4993 41.4585C52.4843 41.4585 53.2828 42.257 53.2828 43.242V50.376C53.2828 51.361 52.4843 52.1595 51.4993 52.1595C50.5143 52.1595 49.7158 51.361 49.7158 50.376V43.242ZM51.4993 59.2935C52.4843 59.2935 53.2828 58.495 53.2828 57.51C53.2828 56.525 52.4843 55.7265 51.4993 55.7265C50.5143 55.7265 49.7158 56.525 49.7158 57.51C49.7158 58.495 50.5143 59.2935 51.4993 59.2935Z",
    fill: "#D91F05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10511_3824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 41,
    fill: "white",
    transform: "translate(23 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnRed);
export default __webpack_public_path__ + "static/media/warnRed.7680a73144d39e5673e9e5916f234579.svg";
export { ForwardRef as ReactComponent };